import { get } from 'framework/api/http';
import { useMutation } from 'react-query';

interface GetAllEnterpriseVideoInterface {
  id: string;
  search: string;
}

export const useGetAllEnterpriseVideos = () => {
  const mutate = useMutation(({ id, search }: GetAllEnterpriseVideoInterface) => {
    return get(`/external-api/get_all_enterprise_videos/${id}/${search}`);
  });

  return mutate;
};

export default useGetAllEnterpriseVideos;
